<template>
<div>
    <div class="sm:flex flex-wrap mb-4 w-screen h-screen">
        <!-- Left Half Desktop -->
        <div class="sm:w-1/2 text-center content-center">
            <!-- Top Mobile -->
        <ResultTitle
        :result="heroResult.title"
        :class="titleclass"
        />
        <span class="mt-4 relative h-12 block mr-20 sm:mr-0 overflow-hidden">
        <img
        style="max-width:none"
        :src="stripes"
        class="sm:hidden block absolute left-0 top-0 max-w-none w-screen"
        />
        <img
        :src="stripes"
        class="hidden sm:block absolute left-0 top-0 max-w-none w-screen"
        />
        </span>
        <!-- Result Character Mobile Toggle -->

        <img
        :src="require('@/assets/img/SVG/'+heroResult.img)"
        class="p-6 block sm:hidden"
        />

            <!-- Bottom Mobile -->
        <div class="lg:w-8/12 text-md lg:ml-40 text-left lg:mt-8 m-3">
        <b class="bg-black text-white py-1 px-1"> About you: </b>
        <AboutTextBox
        :text="heroResult.description"
        :class="aboutclass"
        />
        <div class="text-md text-left mt-2 lg:mt-2">
        <b class="bg-black text-white py-1 px-1"> Watch Out: </b>
        <AboutTextBox
        :text="heroResult.watchout"
        :class="aboutclass"
        />
        <a class="border-black inline-block border-2 px-4 py-2 mt-6 mb-12" target="_blank" :href="pdflink()">Your Download</a>
        </div>
        </div>
        </div>
        <!-- Right Half Desktop -->
        <div class="sm:w-1/2 lg:-mt-32 text-center">
        <img
        :src="require('@/assets/img/SVG/'+heroResult.img)"
        width="650"
        class="lg:absolute lg:mt-12 lg:ml-12 sm:block hidden"
        />
        </div>
  </div>
</div>
</template>

<script>
import * as firebase from "firebase/app"
import { mapState } from "vuex"
import ResultTitle from "@/components/content/title/ResultTitle.vue"
import AboutTextBox from "@/components/content/textbox/AboutTextBox.vue"

export default {
    components: {
        ResultTitle,
        AboutTextBox
    },
    data() {
        return {
            titleclass: "ml-2 lg:ml-40 lg:mt-40 text-left leading-none font-semibold",
            aboutclass: "mt-2",
            stripes: require("@/assets/img/SVG/stripes.svg"),
            results: require("@/data/result/result.json"),
        }
    },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapState({
        user: "user"
      }),
      heroResult() {

        let results = this.results
        let hero = Object

        results.forEach(result => {
          if ( result.id == this.$route.params.score ){
            hero = result
          }
        })
        return hero
      },
     
    },
    methods: {
       pdflink() {
        return "/pdf/" + this.heroResult.pdf;
      },
      updateResult() {

        var firestore = firebase.firestore();
        var uid = this.user.data.uid;
        var email = this.user.data.email;
        var hero = this.user.profile.hero;

        if(!hero) {
          var docRef = firestore.doc("users/" + uid);
          var analyticsRef = firestore.collection("analytics").doc('records');

          analyticsRef.update({
            completed: firebase.firestore.FieldValue.arrayUnion(email),
            heros: firebase.firestore.FieldValue.arrayUnion({
              number: this.heroResult.id,
              uid: uid,
            })
          })

          docRef.update({
            hero: this.heroResult.id
          });
        }
        }

    },
    mounted() {
      this.updateResult()
    }
}
</script>
